export const Width = {
  fitContent: "fit-content",
  minContent: "min-content",
  maxContent: "max-content",
  inherit: "inherit",
  initial: "initial",
  unset: "unset",
  revertLayer: "revert-layer",
  revert: "revert",
  full: "100%",
  auto: "auto",
  none: "0rem", // 0px
  "4xs": "0.1rem", // 2px
  "3xs": "0.25rem", // 4px
  "2xs": "0.5rem", // 8px
  xs: "1rem", // 16px
  sm: "1.5rem", // 24px
  md: "2rem", // 32px
  lg: "2.5rem", // 40px
  xl: "3rem", // 48px
  "2xl": "3.5rem", // 56px
  "3xl": "4rem", // 64px
  "4xl": "4.5rem", // 72px
  "5xl": "5rem", // 80px
  "6xl": "5.5rem", // 88px
  "7xl": "6rem", // 96px
  "8xl": "6.5rem", // 104px
  "9xl": "7rem", // 112px
  "10xl": "7.5rem", // 120px
  "11xl": "8rem", // 128px
  "12xl": "8.5rem", // 136px
  "13xl": "9rem", // 144px
  "14xl": "9.5rem", // 152px
  "15xl": "10rem", // 160px
  "16xl": "10.5rem", // 168px
  "17xl": "11rem", // 176px
  "18xl": "11.5rem", // 184px
  "19xl": "12rem", // 192px
  "20xl": "12.5rem", // 200px
  "21xl": "13rem", // 208px
  "22xl": "13.5rem", // 216px
  "23xl": "14rem", // 224px
  "24xl": "14.5rem", // 232px
  "25xl": "15rem", // 240px
  "26xl": "15.5rem", // 248px
  "27xl": "16rem", // 256px
  "28xl": "16.5rem", // 264px
  "29xl": "17rem", // 272px
  "30xl": "17.5rem", // 280px
  "31xl": "18rem", // 288px
  "32xl": "18.5rem", // 296px
  "33xl": "19rem", // 304px
  "34xl": "19.5rem", // 312px
  "35xl": "20rem", // 320px
  "36xl": "20.5rem", // 328px
  "37xl": "21rem", // 336px
  "38xl": "21.5rem", // 344px
  "39xl": "22rem", // 352px
  "40xl": "22.5rem", // 360px
  "41xl": "23rem", // 368px
  "42xl": "23.5rem", // 376px
  "43xl": "24rem", // 384px
  "44xl": "24.5rem", // 392px
  "45xl": "25rem", // 400px
  0: "0%",
  5: "5%",
  10: "10%",
  15: "15%",
  20: "20%",
  25: "25%",
  30: "30%",
  35: "35%",
  40: "40%",
  45: "45%",
  50: "50%",
  55: "55%",
  60: "60%",
  65: "65%",
  70: "70%",
  75: "75%",
  80: "80%",
  85: "85%",
  90: "90%",
  95: "95%",
  100: "100%",
};

export const Height = {
  fitContent: "fit-content",
  minContent: "min-content",
  maxContent: "max-content",
  inherit: "inherit",
  initial: "initial",
  unset: "unset",
  revertLayer: "revert-layer",
  revert: "revert",
  full: "100%",
  auto: "auto",
  none: "0rem", // 0px
  "4xs": "0.1rem", // 2px
  "3xs": "0.25rem", // 4px
  "2xs": "0.5rem", // 8px
  xs: "1rem", // 16px
  sm: "1.5rem", // 24px
  md: "2rem", // 32px
  lg: "2.5rem", // 40px
  xl: "3rem", // 48px
  "2xl": "3.5rem", // 56px
  "3xl": "4rem", // 64px
  "4xl": "4.5rem", // 72px
  "5xl": "5rem", // 80px
  "6xl": "5.5rem", // 88px
  "7xl": "6rem", // 96px
  "8xl": "6.5rem", // 104px
  "9xl": "7rem", // 112px
  "10xl": "7.5rem", // 120px
  "11xl": "8rem", // 128px
  "12xl": "8.5rem", // 136px
  "13xl": "9rem", // 144px
  "14xl": "9.5rem", // 152px
  "15xl": "10rem", // 160px
  "16xl": "10.5rem", // 168px
  "17xl": "11rem", // 176px
  "18xl": "11.5rem", // 184px
  "19xl": "12rem", // 192px
  "20xl": "12.5rem", // 200px
  "21xl": "13rem", // 208px
  "22xl": "13.5rem", // 216px
  "23xl": "14rem", // 224px
  "24xl": "14.5rem", // 232px
  "25xl": "15rem", // 240px
  "26xl": "15.5rem", // 248px
  "27xl": "16rem", // 256px
  "28xl": "16.5rem", // 264px
  "29xl": "17rem", // 272px
  "30xl": "17.5rem", // 280px
  "31xl": "18rem", // 288px
  "32xl": "18.5rem", // 296px
  "33xl": "19rem", // 304px
  "34xl": "19.5rem", // 312px
  "35xl": "20rem", // 320px
  "36xl": "20.5rem", // 328px
  "37xl": "21rem", // 336px
  "38xl": "21.5rem", // 344px
  "39xl": "22rem", // 352px
  "40xl": "22.5rem", // 360px
  "41xl": "23rem", // 368px
  "42xl": "23.5rem", // 376px
  "43xl": "24rem", // 384px
  "44xl": "24.5rem", // 392px
  "45xl": "25rem", // 400px
  0: "0%",
  5: "5%",
  10: "10%",
  15: "15%",
  20: "20%",
  25: "25%",
  30: "30%",
  35: "35%",
  40: "40%",
  45: "45%",
  50: "50%",
  55: "55%",
  60: "60%",
  65: "65%",
  70: "70%",
  75: "75%",
  80: "80%",
  85: "85%",
  90: "90%",
  95: "95%",
  100: "100%",
};

export const Sizing = { Width, Height };
